import React, { useRef } from 'react';
import ReactDOM from "react-dom";
import { useStoreState } from "easy-peasy";
import {forEach} from "lodash";
import * as Url from "domurl";

import {types} from "../lib/store";
import {CurveTypes} from "./Graph";
import {types as SimulationTypes} from "./Simulation";

function ReportButton() {
  const reportUrl = useStoreState(state => new Url(state.selection.reportUrl));
  const { params: pointParams } = useStoreState(state => state.selection.servicePoint);

  const focusedPair = useStoreState(state => state.selection.focusedPair);
  const focusingCurve = useStoreState(state => state.selection[types.IS_FOCUSING_CURVE]);

  const powerLine = useStoreState(state => state.selection.customizations.powerLine);
  const showAlternativePoint = useStoreState(state => state.selection.showAlternativePoint);

  const hasSoundData = useStoreState(state => state.selection[types.HAS_SOUND_DATA]);
  const acousticConfig = useStoreState(state => state.selection.acousticData);

  const activeSeries =  useStoreState(state => state.selection.activeSeries);

  const fan = useStoreState(state => state.selection.fan);
  const curves = useStoreState(state => state.selection.graph.curves);
  const designPoint = useStoreState(state => state.selection.designPoint);
  const simulationType = useStoreState(state => state.selection.customizations.simulationType);

  /* Reuse same ref on every render
   * https://github.com/facebook/react/issues/15110
   */
  const buttonRef = useRef(null);

  if (!buttonRef.current) {
    // Create and empty once
    buttonRef.current = document.getElementById("menu-pdf");

    if (buttonRef.current) {
      while (buttonRef.current.firstChild) {
        buttonRef.current.removeChild(buttonRef.current.firstChild);
      }
    }
  }

  const domElement = buttonRef.current;

  if (!domElement) {
    return <></>
  }

  if (fan.hasVariants) {
    reportUrl.query.variant = designPoint.variant;
  }

  forEach(pointParams || [], (value, key) => reportUrl.query[key] = value);

  if (simulationType === SimulationTypes.FREQUENCY && designPoint.frequency !== fan.frequency) {
    reportUrl.query.freq = designPoint.frequency;
  }

  if (showAlternativePoint) {
    reportUrl.query.alternativePoint = true;
  }

  if (powerLine.motorId) {
    reportUrl.query.motor = powerLine.motorId;
  }

  if (hasSoundData) {
    reportUrl.query.acu = acousticConfig.type;
    reportUrl.query.acu_dis = acousticConfig.distance;
    reportUrl.query.acu_directionality = acousticConfig.directionality;
  }

  const disabledCurves = [];
  forEach(CurveTypes, ({type, abbr}) => {
    if (activeSeries.indexOf(type) === -1) { // Not visible
      disabledCurves.push(abbr);
    }
  });

  if(disabledCurves.length > 0) {
    reportUrl.query.disabledCurves = disabledCurves.join(",");
  }

  if (focusingCurve && curves) {
    reportUrl.query.focusedCurve = curves
      .filter(curve => curve.pair_identifier === focusedPair)
      .map(curve => curve.id)
      .join(",");
  }

  return ReactDOM.createPortal(
    <a className="menu-item pdf" title="pdf" href={ reportUrl } />
    , domElement
  );
}

export default ReportButton;
